import { useMutation } from '@tanstack/react-query';
import { useDialogs, useNotifications } from '@toolpad/core';
import { useNavigate } from 'react-router';
import {
    Card,
    CardContent,
    CardHeader,
    Stack,
    Typography,
} from '@mui/material';
import Button from '@mui/material/Button';

import Api from '@barboxx/api';
import { Product } from '@barboxx/models';

interface Props {
    product: Product.DetailsResponse;
}

export const ProductDeleteCard = ({ product }: Props) => {
    const notifications = useNotifications();
    const navigate = useNavigate();
    const dialog = useDialogs();

    const mutateDeleteProduct = useMutation({
        mutationKey: ['deleteProduct', product.id],
        mutationFn: () => Api.Products.Products.deleteProduct(product),
    });

    const onDelete = async () => {
        const deleteConfirmed = await dialog.confirm(
            'Are you sure you want to Delete this Product!',
            {
                severity: 'error',
                okText: 'Delete',
                title: 'Delete Product',
            }
        );

        if (!deleteConfirmed) {
            return;
        }

        mutateDeleteProduct
            .mutateAsync()
            .then(({ data }) => {
                notifications.show(`Deleted product ${product.name}!`, {
                    severity: 'success',
                });
                navigate(-1);
            })
            .catch(e => {
                notifications.show('Error Deleting product!', {
                    severity: 'error',
                });
            });
    };

    return (
        <Card>
            <CardHeader title="Delete Product" />
            <CardContent>
                <Stack gap={2} direction="row">
                    <Typography flex={1}>
                        Are you sure you want to Delete this product?
                    </Typography>

                    <Button onClick={onDelete} color="error" variant="outlined">
                        Delete
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
};
